import React from 'react'

// Translucent tint driven by theme tokens (color-mix over the semantic var) so each
// badge adapts to light/dark automatically instead of using fixed hex colors.
const tint = (cssVar) => ({
  backgroundColor: `color-mix(in srgb, var(${cssVar}) 14%, transparent)`,
  color: `var(${cssVar})`,
})

const PROVIDERS = {
  equifax: { label: 'EFX', style: tint('--color-info-main') },
  crs: { label: 'EFX', style: tint('--color-info-main') }, // fallback when CRS doesn't return bureau name
  experian: { label: 'EXP', style: tint('--color-warning-main') },
  transunion: { label: 'TU', style: tint('--color-success-main') },
}

const DEFAULT = {
  label: '?',
  style: { backgroundColor: 'var(--color-gray-150)', color: 'var(--color-text-secondary)' },
}

const ProviderBadge = ({ sourceType }) => {
  const key = (sourceType || '').toLowerCase()
  const { label, style } = PROVIDERS[key] || DEFAULT
  return (
    <span
      className="flex-shrink-0 px-1.5 py-0.5 text-[10px] font-semibold rounded-md"
      style={style}
      title={sourceType || 'Unknown'}
    >
      {label}
    </span>
  )
}

export default ProviderBadge
